<template>
  <v-snackbar
    app
    top
    :color="notification.type"
    :timeout="notification.timeout"
    :value="!dismissed"
    @input="closeNotification"
  >
    <strong class="app-notifications--title">
      {{ notification.title }}
    </strong>

    <div
      class="app-notifications--message"
      v-html="message"
    />

    <template #action="{ attrs }">
      <tc-v-btn
        class="app-notifications--close-button"
        dark
        text
        v-bind="attrs"
        small
        @click="closeNotification"
      >
        <v-icon>
          mdi-close
        </v-icon>
      </tc-v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { NotifyMessage } from '@/service/notification/NotifyMessage'

export default {
  name: 'ApplicationNotification',
  props: {
    notification: {
      type: NotifyMessage,
      required: true
    }
  },
  data: () => ({
    dismissed: false
  }),
  computed: {
    message () {
      const { message, details } = this.notification || {}
      return details ? `${message} - ${details}` : message
    }
  },
  methods: {
    closeNotification () {
      this.dismissed = true
    }
  }
}
</script>
